<template>
    <div class="qwMessage">
        <div class="searchForm" >
            <el-form  ref="form" :model="form" label-width="75px" @submit.native.prevent>
                <el-row :gutter="10" >
                    <el-col :span="4">
                        <el-form-item label="批次号" label-width="60px">
                            <el-input v-model="form.batchNumber" autocomplete="off" placeholder="批次号"
                                      @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="域账号" label-width="60px">
                            <el-input v-model="form.adAccount" autocomplete="off" placeholder="域账号"
                                      @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="域群组" label-width="60px">
                            <el-input v-model="form.adGroup" autocomplete="off" placeholder="批次号"
                                      @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="部门编码">
                            <el-input v-model="form.department" autocomplete="off" placeholder="批次号"
                                      @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="发送日期">
                            <el-date-picker
                                    v-model="form.sendTime"
                                    type="datetimerange"
                                    size="small"
                                    :picker-options="pickerOptions"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="4">
                        <el-form-item label="模板类型">
                            <el-select v-model="form.qwMsgType" placeholder="请选择企微消息类型" @change="getMessageList(1)">
                                <el-option
                                        v-for="item in qwMessageOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="发送状态">
                            <el-select v-model="form.status" placeholder="请选择发送状态" clearable @change="getMessageList(1)"
                                       >
                                <el-option label="全部" value=""/>
                                <el-option label="发送成功" value="1"/>
                                <el-option label="发送失败" value="2"/>
                                <el-option label="消息拦截" value="5"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-button  style="margin-left: 20px" type="primary"  @click="getMessageList(1)">查询</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="dataBox">
            <el-table v-loading="loading" element-loading-text="数据加载中" :data="tableData" stripe>
                <el-table-column type="expand">
                    <template slot-scope="scope">
                        <el-form label-position="left" class="table-expand">
                            <el-form-item>
                                <el-row>
                                    <el-col :span="2" class="expandLabel">优先级</el-col>
                                    <el-col :span="21" class="expandContent">{{parsePriority(scope.row.priority)}}</el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item>
                                <el-row>
                                    <el-col :span="2" class="expandLabel">模板编码</el-col>
                                    <el-col :span="21" class="expandContent">{{scope.row.templateCode}}</el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item v-if="form.qwMsgType!==1">
                                <el-row>
                                    <el-col :span="2" class="expandLabel">描述</el-col>
                                    <el-col :span="21" class="expandContent">{{ scope.row.description }}</el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item v-if="form.qwMsgType!==1">
                                <el-row>
                                    <el-col :span="2" class="expandLabel">跳转链接</el-col>
                                    <el-col :span="21" class="expandContent">{{ scope.row.url }}</el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item v-if="form.qwMsgType===2">
                                <el-row>
                                    <el-col :span="2" class="expandLabel">图片链接</el-col>
                                    <el-col :span="21" class="expandContent">{{ scope.row.picUrl }}</el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item v-if="form.qwMsgType===3">
                                <el-row>
                                    <el-col :span="2" class="expandLabel">按钮文本</el-col>
                                    <el-col :span="21" class="expandContent">{{ scope.row.btnTxt }}</el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column prop="batchNumber" width="200" label="消息批次号"/>
                <el-table-column prop="qwMsgType" label="企微消息类型" width="140">
                    <template slot-scope="scope">
                        <span>{{ parseQwMessageType(scope.row.qwMsgType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="form.qwMsgType!==1" prop="title" show-overflow-tooltip label="标题"/>
                <el-table-column v-if="form.qwMsgType===1" prop="content" show-overflow-tooltip label="内容"/>
                <el-table-column v-if="form.qwMsgType===2" label="图片链接预览">
                    <template slot-scope="scope" v-if="form.qwMsgType===2">
                        <el-image
                                style="width: 120px; height: 80px"
                                :src="scope.row.picUrl"
                                :preview-src-list="[scope.row.picUrl]"
                                :fit=imgFit
                                :onerror="errorImg(scope)"
                        >
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="adAccount" label="接受域账号" width="140"/>
                <el-table-column prop="sendTime" sortable label="发送时间" width="200">
                    <template slot-scope="scope">
                        <span>{{ parseTime(scope.row.sendTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="发送状态" width="140">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : (scope.row.status === 2 || scope.row.status === 5)?'danger':'warning'">
                            {{parseStatus(scope.row.status) }}
                        </el-tag>
                        <i v-if="scope.row.status === 5 && scope.row.batchNumber" @click="handleStatusDetail(scope.row.batchNumber)" class="el-icon-warning-outline btnclass"></i>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :page-sizes="[10,20,50]"
                    :page-size="pageSize"
                    :current-page.sync="pageNum"
                    @size-change="sizeChangeClick"
                    @current-change="currChangeClick"
                    @prev-click="prevClick"
                    @next-click="nextClick"
            />
        </div>
    </div>
</template>

<script>
    import {parsePriority} from "@/util/index";
    import {parseTime} from "@/util/index";
    import httpUrl from "@/static/configUrl";

    export default {
        name: "qwMessage",
        components: {},
        data() {
            return {
                imgFit: 'contain',
                imgPrefix: "https://images.weserv.nl/?url=",
                // clientId: this.$store.state.request.appId,
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        if (minDate && !maxDate) {
                            this.$set(this, 'selectDate', minDate.getTime())
                        } else {
                            this.$set(this, 'selectDate', '')
                        }
                    },
                    disabledDate: (time) => {
                        if (this.selectDate) {
                            const maxTime = this.selectDate + 30 * 24 * 3600 * 1000
                            const minTime = this.selectDate - 30 * 24 * 3600 * 1000
                            return time.getTime() > maxTime || time.getTime() < minTime
                        }
                        return false
                    },
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                selectDate: '',
                form: {
                    batchNumber: '',
                    adAccount: '',
                    adGroup: '',
                    department: '',
                    sendTime: [],
                    qwMsgType: 1,
                    type: 1,
                    status: ''
                },
                qwMessageOptions: [{
                    "label": "文本消息",
                    "value": 1
                }, {
                    "label": "图文消息",
                    "value": 2
                }, {
                    "label": "卡片消息",
                    "value": 3
                }
                ],
                tableData: [],
                total: 0,
                pageNum: 1,
                pageSize: 10,
                loading: false,
                dialogEditFormVisible: false,
                dialogFormVisible: false,
            }
        },
        computed: {
            clientId(){
                return this.$store.state.request.appId
            }
        },
        watch:{
            clientId() {
                this.getMessageList()
            }
        },
        created() {
            this.initDatePickValue()
            this.getMessageList()
        },
        mounted() {
        },
        methods: {
            errorImg(scope) {
                return scope.row.picUrl
            },
            parseTime,
            parsePriority,
            parseStatus(status) {
                switch (status) {
                    case 1:
                        return "发送成功"
                    case 2:
                        return "发送失败"
                    case 3:
                        return "待发送"
                    case 5:
                        return "消息拦截"
                    default:
                        return "未知状态"
                }
            },
            parseQwMessageType(qwType) {
                switch (qwType) {
                    case 1:
                        return "文本消息"
                    case 2:
                        return "图文消息"
                    case 3:
                        return "卡片消息"
                    default:
                        return "未知类型"
                }
            },
            initDatePickValue() {
                let d = new Date
                this.form.sendTime.push(d)
                let startTime = d.getTime() - 24 * 3600 * 1000 * 30;
                let startDate = new Date(startTime)
                this.form.sendTime.unshift(startDate)
            },
            getMessageList(_pageNum) {
                const that = this
                if (_pageNum === 1) {
                    that.pageNum = 1
                }
                that.loading = true
                const _data = {
                    curl:httpUrl.messageUrl + '/message/list',
                    sendTime: that.form.sendTime,
                    clientId: that.clientId,
                    batchNumber: that.form.batchNumber,
                    adAccount: that.form.adAccount,
                    adGroup: that.form.adGroup,
                    department: that.form.department,
                    // searchParam: that.form.searchParam,
                    status: that.form.status,
                    type: that.form.type,
                    qwMsgType: that.form.qwMsgType,
                    page: that.pageNum,
                    size: that.pageSize
                }
                that.$store.dispatch('httpPost', _data).then(function (res) {
                    that.tableData = res.data.content
                    that.total = parseInt(res.data.total)
                    that.loading = false
                }, function (err) {
                    console.log(err.message)
                    that.loading = false
                })
            },
            // 分页 每页条数改变
            sizeChangeClick(val) {
                this.pageSize = val
                this.getMessageList()
            },
            // 分页 改变当前页
            currChangeClick(val) {
                this.pageNum = val
                this.getMessageList()
            },
            // 分页 上一页
            prevClick(val) {
                this.pageNum = val
                this.getMessageList()
            },
            // 分页 下一页
            nextClick(val) {
                this.pageNum = val
                this.getMessageList()
            },
            // 消息拦截详情
            handleStatusDetail(batchNumber) {
                const _data = {
                    curl: httpUrl.messageUrl + '/message/intercept/reason/' + batchNumber
                }
                this.$store.dispatch('httpGet', _data).then((res) => {
                    this.$alert(res.data.comments, '发送状态详情')
                }, function (err) {
                    console.log(err.message)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .qwMessage {
        .searchForm {
            /*background: #fff;*/
            /*padding-top: 10px;*/
            padding-left: 10px;
            /*height: 45px;*/
            .el-input {
                width: 200px;
            }
        }
    }
</style>
<style>
    .qwMessage .searchForm .el-form-item {
        display: inline-block;
    }

    .qwMessage .searchForm .el-form-item:nth-child(2) {
        margin-left: 30px;
    }

    .qwMessage .table-expand {
        font-size: 0;
    }

    .qwMessage .table-expand .expandLabel {
        width: 90px;
        color: #99a9bf;
    }

    .qwMessage .table-expand .expandContent {
        word-break: break-all;
    }

    .qwMessage .table-expand .el-form-item {
        margin-left: 50px;
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
</style>

